import React, { ReactNode, useMemo, useReducer } from 'react';
import { useParams } from 'react-router-dom';
import { createReducerFunction } from 'immer-reducer';

import { actions, OnlineBookingStateContext } from './context';
import { initialState as defaultState, OnlineBookingReducer } from './reducer';
import type { State } from './types';

interface Props {
  initialState?: Partial<State>;
  children: ReactNode;
}

const reducer = createReducerFunction(OnlineBookingReducer);

export const OnlineBookingStateProvider = ({ children, initialState }: Props) => {
  const { token } = useParams<{ token: string }>();

  const [state, dispatch] = useReducer(reducer, { ...defaultState, token, ...initialState });

  const value = useMemo(
    () => ({
      state,
      dispatch,
      actions,
    }),
    [state, dispatch]
  );

  return <OnlineBookingStateContext.Provider value={value}>{children}</OnlineBookingStateContext.Provider>;
};

export type { State } from './types';
